import { render, staticRenderFns } from "./AffiliationList.vue?vue&type=template&id=04081a29&"
import script from "./AffiliationList.vue?vue&type=script&lang=js&"
export * from "./AffiliationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports